import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Constants from '../../../app/utils/constants'
import Footer from '../../organisms/Footer/Footer'
import BlogDetailsHeroSection from '../../organisms/BlogDetailsHeroSection/BlogDetailsHeroSection'
import BlogDetails from '../../molecules/BlogDetails/BlogDetails'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import colors from '../../theme/color'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import commonfooter from '../../../assets/images/commonfooter.webp'

const BlogDetailsPage = () => {
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()
  const { blogPageCards, blogDetailArticle } = Constants

  const card = useMemo(
    () => blogPageCards.find((c) => c.slug === slug),
    [blogPageCards, slug],
  )

  if (!card || !slug) {
    return (
      <main className="min-h-screen text-white" style={{ backgroundColor: colors.deepNavy }}>
        <div className="mx-auto flex max-w-lg flex-col items-center gap-6 px-6 py-24 text-center">
          <p className="font-gilroy-medium text-gray-400">This article could not be found.</p>
          <button
            type="button"
            onClick={() => navigate('/blog')}
            className="rounded-full bg-purple px-6 py-3 font-rajdhani font-semibold text-white transition hover:opacity-90"
          >
            Back to blog
          </button>
        </div>
        <Footer />
      </main>
    )
  }

  const heroSubtitle = `${card.category.trim()} · ${card.date}`

  return (
    <main className="min-h-screen text-white" style={{ backgroundColor: colors.deepNavy }}>
      <BlogDetailsHeroSection title={card.heading} subtitle={heroSubtitle} />
      <BlogDetails
        article={{
          ...blogDetailArticle,
          introHeading: card.heading,
          introMeta: `${card.category.trim()} — ${card.date}`,
        }}
      />
       <CommanFooterCard
 paragraph="We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events."
imageSrc={commonfooter}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #874bff7d 17.11%, rgba(135, 75, 255, 0) 100%)"
/>
      <Testimonial className="mx-auto mb-20 max-w-[90%]" />
      <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
      <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
          <Message />
          <Questions />
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default BlogDetailsPage
